import { Alert, Grid } from '@mui/material';

import { useDispatch } from 'react-redux';

import { ReactComponent as DeleteAlertIcon } from 'common/assets/images/exclamation.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import ModalEle from 'common/components/Modal/ModalEle';
import { CONTROL_TESTSCRIPT_ACTIONS_TYPE } from 'common/constants/TestScriptHubControlConstants';
import { setControlStepsInfo } from 'common/store/reducer/controlTestScriptReducer';
import { toSentenceCase } from 'common/utils/utilFunctions';

import styles from '../ControlTestStepAddEditActions/ControlTestStepAddEditActions.module.scss';
import ControlTestStepModalHeader from '../ControlTestStepModalHeader/ControlTestStepModalHeader';

import actionStyles from './ControlTestStepActions.module.scss';

interface IControlTestStepActionsProps {
	type: string;
	title: string;
	alertText: string;
	openModal: boolean;
	testScriptData?: any;
	ModalHeaderImg?: any;
	handleClose: () => void;
	handleAction: (data: any) => void;
	rowIndex?: any;
	onClickDelete?: (rowData: any, type: any) => void; // Add this prop
}

const { DELETE_TEST_ACTION, CANCEL_TEST_ACTION, REGENERATE_TEST_ACTION } =
	CONTROL_TESTSCRIPT_ACTIONS_TYPE;

const ControlTestStepActions = (props: IControlTestStepActionsProps) => {
	const {
		type,
		title,
		openModal,
		onClickDelete,
		testScriptData,
		ModalHeaderImg,
		handleClose,
		alertText,
		handleAction,
		rowIndex,
	} = props;

	const { statusWarningColor, textColor, statusWarningColorRed } = actionStyles;

	const dispatch = useDispatch();

	const handleModalClose = () => {
		handleClose();
	};

	const actionHandler = () => {
		dispatch(setControlStepsInfo(false));
		if (type !== DELETE_TEST_ACTION) {
			dispatch(setControlStepsInfo(true));
			handleAction(testScriptData);
		} else {
			const indexInfo = rowIndex;
			handleAction(indexInfo);
			if (onClickDelete && testScriptData !== undefined) {
				// Check if onClickDelete and testScriptData are defined
				onClickDelete(testScriptData, rowIndex); // Call onClickDelete only if it's defined
			}
		}
	};
	const getButtonLabel = (type: string) => {
		switch (type) {
			case DELETE_TEST_ACTION:
				return 'Delete';
			case CANCEL_TEST_ACTION:
				return 'Cancel';
			case REGENERATE_TEST_ACTION:
				return 'Regenerate';
			default:
				return 'Delete';
		}
	};
	return (
		<ModalEle open={openModal} handleClose={handleModalClose}>
			<Grid container xs={12} lg={12} sm={12} md={12} direction="row">
				<Grid
					direction="row"
					container
					item
					xs={12}
					lg={12}
					sm={12}
					md={12}
					spacing={1}
				>
					<ControlTestStepModalHeader
						title={title}
						handleModalClose={handleModalClose}
						ModalHeaderImg={ModalHeaderImg}
					/>
					{!ModalHeaderImg && (
						<p className={actionStyles['add-control-test-step-title']}>
							{' '}
							Are you sure you want to delete this step?{' '}
						</p>
					)}
				</Grid>
				<Grid
					container
					item
					direction="row"
					xs={12}
					lg={12}
					sm={12}
					md={12}
					mt={2}
				>
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						className={styles['add-control-test-step-label']}
					>
						{!ModalHeaderImg ? (
							<Alert
								severity="warning"
								sx={{
									background: statusWarningColorRed,
									'& .MuiAlert-icon': {
										display: 'none',
									},
								}}
							>
								<Grid container alignItems="center" spacing={2}>
									<Grid item>
										<DeleteAlertIcon />
									</Grid>
									<Grid
										item
										className={actionStyles['delete-control-test-step-title']}
									>
										{toSentenceCase(alertText)}
									</Grid>
								</Grid>
							</Alert>
						) : (
							<Alert
								severity="warning"
								sx={{
									background: statusWarningColor,
									color: textColor,
									'& .MuiAlert-icon': {
										color: textColor,
									},
								}}
							>
								{alertText}
							</Alert>
						)}
					</Grid>
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						className={styles['add-control-test-step-btngrp']}
					>
						<ButtonComp
							btnType="secondary"
							clickHandler={handleModalClose}
							data-testid="addtestmodal-cancel"
						>
							{!ModalHeaderImg ? 'Cancel' : 'Dismiss'}
						</ButtonComp>
						<ButtonComp
							btnType="primary"
							clickHandler={actionHandler}
							data-testid="addtestmodal-save"
						>
							{getButtonLabel(type)}
						</ButtonComp>
					</Grid>
				</Grid>
			</Grid>
		</ModalEle>
	);
};

export default ControlTestStepActions;
